import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Contact, ContactInput } from '../../../../../types/contact';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import { TextInput } from '../../../../components/TextInput';
import { DeleteButton } from '../../../../components/Button';
import CustomFieldInput from '../../../Common/CustomFieldInput';
import { UserContext } from '../../../../../context/UserContext';
import { CustomFieldContext } from '../../../../../context/CustomFieldContext';
import { ContactContext } from '../../../../../context/ContactContext';
import { ProductMasterDataContext } from '../../../../../context/ProductMasterDataContext';
import { Routing } from '../../../../../util/routes.util';
import DeleteContactModal from '../Modals/DeleteContactModal';

interface ContactInfoPaneProps {
  contact?: Contact;
  setError: (error: string) => void;
}

export default function ContactInfoPane({ contact, setError }: ContactInfoPaneProps) {
  const navigate = useNavigate();

  const { companyUsers } = useContext(UserContext);
  const { customFields } = useContext(CustomFieldContext);
  const { contacts } = useContext(ContactContext);
  const { productMasterData } = useContext(ProductMasterDataContext);

  const [input, setInput] = useState<ContactInput>(new ContactInput(contact));
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);

  const isExternal = !!input.externalIdentifier?.externalId;

  return (
    <>
      {input.id && openDeleteModal ? (
        <DeleteContactModal
          contact={input}
          open={openDeleteModal}
          setOpen={setOpenDeleteModal}
          onDeleted={() => navigate(Routing.operations.contacts.overview())}
        />
      ) : null}
      <div className='flex h-full flex-col justify-between'>
        <div className='flex flex-grow flex-col gap-8'>
          <p className='page-title'>{t(TranslationKey.contact).singular.upper}</p>
          <div className='flex flex-grow flex-col gap-4'>
            <div>
              <TextInput
                mandatory={true}
                label={t(TranslationKey.name).singular.label}
                placeholder={t(TranslationKey.name).singular.label}
                value={contact?.name}
                disabled={isExternal || true} // TODO: Enable when update is implemented
                onChange={v => setInput(input => input.withName(v))}
              />
            </div>
            <div className='grid grid-cols-3 gap-2'>
              {[...input.customFields.values()].map((value, index) => (
                <div className='col-span-1'>
                  <CustomFieldInput
                    disabled={isExternal || true} // TODO: Enable when update is implemented
                    item={customFields.get(value.id)}
                    value={value.value}
                    entity={input}
                    onChange={setInput}
                    users={companyUsers}
                    contacts={contacts}
                    productMasterData={productMasterData}
                  />
                </div>
              ))}
            </div>
            {/* <div className='grid h-full grid-cols-3 gap-4'>
              <div className='col-span-1'>
                <div className='mb-2 flex justify-between'>
                  <p className='sub-title'>{`${t(TranslationKey.address).plural.label} (${
                    input.addresses?.length || 0
                  })`}</p>
                  <AddButton disabled={isExternal} onClick={() => {}} />
                </div>
                <div className='flex flex-col gap-2'>
                  {input.addresses?.map((address, index) => (
                    <TextInput
                      disabled={true}
                      label={address.type || address.name || t(TranslationKey.address).singular.label}
                      value={`${address.addressLine1} ${address.postalCode} ${address.city} ${address.region} ${address.countryCode}`}
                    />
                  ))}
                </div>
              </div>
              <div className='col-span-1'>
                <div className='mb-2 flex justify-between'>
                  <p className='sub-title'>{`${t(TranslationKey.email).plural.label} (${
                    input.emails?.length || 0
                  })`}</p>
                  <AddButton disabled={isExternal} onClick={() => {}} />
                </div>
                <div className='flex flex-col gap-2'>
                  {input.emails?.map((email, index) => (
                    <TextInput label={t(TranslationKey.email).singular.label} disabled={true} value={email} />
                  ))}
                </div>
              </div>
              <div className='col-span-1'>
                <div className='flex justify-between'>
                  <p className='sub-title'>{`${t(TranslationKey.phone).plural.label} (${
                    input.phones?.length || 0
                  })`}</p>
                  <AddButton disabled={isExternal} onClick={() => {}} />
                </div>
                <div className='flex flex-col gap-2'>
                  {input.phones?.map((phone, index) => (
                    <TextInput label={t(TranslationKey.phone).singular.label} disabled={true} value={phone} />
                  ))}
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div>
        <DeleteButton disabled={isExternal || !input.id} onClick={() => setOpenDeleteModal(true)} />
      </div>
    </>
  );
}
